import {
  Directive,
  Input,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  NgZone,
} from '@angular/core';
import { zip } from 'rxjs';
import { AmapToolBarService, AMapToolBar } from './amap-tool-bar.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { EventBinderService } from '../../shared/event-binder.service';
import { getOptions, ChangeFilter } from '../../utils';
import { IPixel } from '../../interfaces';
import { PixelService } from '../../shared/pixel.service';
import { AMapService } from '../../shared/amap.service';

const TAG = 'amap-tool-bar';
const ToolBarOptions = [
  'offset',
  'position',
  'ruler',
  'noIpLocate',
  'locate',
  'liteStyle',
  'direction',
  'autoPosition',
  'locationMarker',
  'useNative',
];

@Directive({
  selector: 'amap-tool-bar',
  exportAs: 'tool-bar',
  providers: [AmapToolBarService],
})
export class AmapToolBarDirective implements OnInit, OnChanges, OnDestroy {
  // ---- Options ----
  /**
   * ç¸å¯¹äºå°å¾å®¹å¨å·¦ä¸è§çåç§»é
   */
  @Input() offset: AMap.Pixel | IPixel;
  /**
   * æ§ä»¶åé ä½ç½®
   * LT: å·¦ä¸è§
   * RT: å³ä¸è§
   * LB: å·¦ä¸è§
   * RB: å³ä¸è§
   */
  @Input() position: AMapToolBar.Position;
  /**
   * æ å°ºé®çæ¯å¦å¯è§
   */
  @Input() ruler: boolean;
  /**
   * å®ä½å¤±è´¥åï¼æ¯å¦å¼å¯ IP å®ä½
   */
  @Input() noIpLocate: boolean;
  /**
   * æ¯å¦æ¾ç¤ºå®ä½æé®
   */
  @Input() locate: boolean;
  /**
   * æ¯å¦ä½¿ç¨ç²¾ç®æ¨¡å¼
   */
  @Input() liteStyle: boolean;
  /**
   * æ¹åé®çæ¯å¦å¯è§
   */
  @Input() direction: boolean;
  /**
   * æ¯å¦èªå¨å®ä½ï¼å³å°å¾åå§åå è½½å®æåï¼æ¯å¦èªå¨å®ä½çç¨æ·æå¨å°ï¼ä»å¨æ¯æ HTML5 çæµè§å¨ä¸­ææ
   */
  @Input() autoPosition: boolean;
  /**
   * èªå®ä¹å®ä½å¾æ ï¼å¼ä¸º Marker å¯¹è±¡
   */
  @Input() locationMarker: AMap.Marker;
  /**
   * æ¯å¦ä½¿ç¨é«å¾·å®ä½ SDK ç¨æ¥è¾å©ä¼åå®ä½ææ
   */
  @Input() useNative: boolean;
  /**
   * é¢å¤: æ¯å¦éè
   */
  @Input() hidden = false;

  // amap-tool-bar events:
  @Output() naReady = new EventEmitter();
  @Output() naShow: EventEmitter<any>;
  @Output() naHide: EventEmitter<any>;
  @Output() naLocation: EventEmitter<any>;
  @Output() naZoomChanged: EventEmitter<any>;

  private inited = false;

  constructor(
    protected os: AmapToolBarService,
    protected binder: EventBinderService,
    private amaps: AMapService,
    private pixels: PixelService,
    private logger: LoggerService,
    private ngZone: NgZone,
  ) {
    const target = this.os.get();
    this.naShow = this.binder.bindEvent(target, 'show');
    this.naHide = this.binder.bindEvent(target, 'hide');
    this.naLocation = this.binder.bindEvent(target, 'location');
    this.naZoomChanged = this.binder.bindEvent(target, 'zoomchanged');
  }

  ngOnDestroy() {
    this.os.destroy();
  }

  ngOnInit() {
    this.amaps.get().subscribe(() => {
      this.logger.d(TAG, 'initializing ...');
      const options = getOptions<AMapToolBar.Options>(this, ToolBarOptions);
      if (this.offset) {
        options.offset = this.pixels.create(this.offset);
      }
      this.logger.d(TAG, 'options:', options);
      this.os.create(options).subscribe(m => {
        this.ngZone.run(() => this.naReady.emit(m));
        this.logger.d(TAG, 'toolbar is ready.');
      });
      this.inited = true;
      this.get().subscribe(m => {
        this.hidden ? m.hide() : m.show();
      });
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const filter = ChangeFilter.of(changes);
    const toolbar = this.get();
    if (!this.inited) {
      return;
    }
    zip(filter.notEmpty<AMap.Pixel | IPixel>('offset'), toolbar).subscribe(([v, m]) =>
      m.setOffset(this.pixels.create(v)),
    );
    zip(filter.has<boolean>('hidden'), toolbar).subscribe(([v, m]) => (v ? m.hide() : m.show()));
  }

  /**
   * è·åå·²åå»ºç AMap.ToolBar å¯¹è±¡
   */
  get() {
    return this.os.get();
  }

  doLocation() {
    this.os.get().subscribe(toolbar => {
      toolbar.doLocation();
    });
  }
}
